// extracted by mini-css-extract-plugin
export default {"container":"MobileMenu_container__5XiUy","backdrop":"MobileMenu_backdrop__Zn9U8","mobileMenu":"MobileMenu_mobileMenu__kcnCt"};